// src/components/admin/design/GenericFallbackPreview.tsx
"use client";

import React from "react";
import { useDetectedAdminTheme } from "./UniversalProductCardPreview";

export interface PreviewProps {
  sectionKey: string;
  variantId: string;
  theme?: "dark" | "light";
  primaryColor?: string;
}

export default function GenericFallbackPreview({
  sectionKey,
  variantId,
  theme: propTheme,
  primaryColor = "#059669",
}: PreviewProps) {
  const [activeTheme] = useDetectedAdminTheme(propTheme);
  const isLight = activeTheme === "light";

  return (
    <div
      className={`p-10 rounded-2xl border-2 border-dashed text-center space-y-2 w-full transition-colors ${
        isLight
          ? "bg-white border-slate-300 text-slate-900"
          : "bg-slate-900/70 border-slate-700 text-white"
      }`}
    >
      <span className="text-3xl block">🎨</span>
      <h3
        className={`text-sm font-black capitalize ${
          isLight ? "text-slate-900" : "text-white"
        }`}
      >
        {sectionKey.replace(/_/g, " ")} Live Preview
      </h3>
      <p
        className={`text-xs max-w-md mx-auto ${
          isLight ? "text-slate-500" : "text-slate-400"
        }`}
      >
        Selected layout:{" "}
        <strong style={{ color: primaryColor }} className="font-mono">
          {variantId}
        </strong>
        . This design template will be seamlessly rendered on your live storefront.
      </p>
    </div>
  );
}